import { FunctionComponent } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import config from '../config';

interface TurnstileWidgetProps {
  humanVerificationWasSuccessful: boolean;
  setHumanVerificationWasSuccessful: (value: boolean) => void;
}

export const TurnstileWidget: FunctionComponent<TurnstileWidgetProps> = ({
  humanVerificationWasSuccessful,
  setHumanVerificationWasSuccessful
}) => {
  const handleSuccess = () => {
    setHumanVerificationWasSuccessful(true);
  };

  if (humanVerificationWasSuccessful) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        background: 'rgba(255,255,255,0.8)'
      }}
    >
      <Turnstile siteKey={config.REACT_APP_TURNSTILE_SITE_KEY} onSuccess={handleSuccess} />
    </div>
  );
};
